
import { faqCategories, faqItems } from '../../../mocks/faq';

interface FAQSidebarProps {
  activeSection: string;
}

export default function FAQSidebar({ activeSection }: FAQSidebarProps) {
  const categories = faqCategories.filter((c) => c.id !== 'all');

  const getCategoryCount = (catId: string) => {
    return faqItems.filter((item) => item.category === catId).length;
  };

  const scrollToSection = (catId: string) => {
    const el = document.getElementById(`faq-${catId}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <aside className="sticky top-28">
      <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">Categories</h4>
      <nav className="space-y-1">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => scrollToSection(cat.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all duration-200 cursor-pointer ${
              activeSection === cat.id
                ? 'bg-teal-50 text-teal-700 font-semibold'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <div className={`w-8 h-8 flex items-center justify-center rounded-lg shrink-0 ${
              activeSection === cat.id ? 'bg-teal-100 text-teal-600' : 'bg-gray-100 text-gray-400'
            }`}>
              <i className={`${cat.icon} text-base`}></i>
            </div>
            <span className="text-sm flex-1">{cat.label}</span>
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
              activeSection === cat.id ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-500'
            }`}>
              {getCategoryCount(cat.id)}
            </span>
          </button>
        ))}
      </nav>

      <div className="mt-8 p-5 bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-xl border border-teal-100">
        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-teal-600 text-white mb-3">
          <i className="ri-chat-smile-3-line text-xl"></i>
        </div>
        <h4 className="text-sm font-bold text-gray-900 mb-1">Still have questions?</h4>
        <p className="text-xs text-gray-600 mb-3 leading-relaxed">
          Can&#39;t find what you&#39;re looking for? We&#39;re here to help.
        </p>
        <a
          href="mailto:info@roseville.ca.us"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-700 hover:text-teal-800 transition-colors cursor-pointer"
        >
          <i className="ri-mail-send-line"></i>
          Contact Us
        </a>
      </div>
    </aside>
  );
}
